//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class MessageTemplatePlaceholder extends ItemBase {
    readonly Title: string | null = null;
    readonly Placeholder: string | null = null;
    readonly SampleText: string | null = null;
    readonly Required: boolean = false;

    constructor(initializer?: Partial<Omit<MessageTemplatePlaceholder, "Title" | "Placeholder" | "SampleText" | "Required">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "MessageTemplatePlaceholder";
}
